import React, { useEffect, useState } from "react";

export const ClientLogos = () => {
  const [clients, setClients] = useState([]);

  const safePath = (path) =>
    path.split("/").map((p) => encodeURIComponent(p.trim())).join("/");

  useEffect(() => {
    fetch("/images/Clients/clients.json")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data.map((client) => ({
          id: client.id,
          name: client.name,
          logo: safePath(`/images/Clients/${client.file}`),
        }));
        setClients(formatted);
      });
  }, []);

  return (
    <section
      id="client"
      className="py-16 bg-white dark:bg-gray-800 border-y border-gray-200 dark:border-gray-700"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
            Trusted By Leading Organizations
          </p>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Our Valued Clients
          </h2>
        </div>

        {/* Logo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8 items-center">
          {clients.map((client, index) => (
            <div
              key={client.id}
              className="flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-900 rounded-xl 
                         transition-transform duration-300 cursor-pointer
                         hover:scale-105 hover:shadow-xl hover:bg-gray-100 dark:hover:bg-green-800 glow-hover"
              style={{
                opacity: 0,
                transform: "translateY(16px)",
                animation: `fadeInUp 0.5s ease forwards`,
                animationDelay: `${index * 0.1}s`,
              }}
              title={client.name}
            >
              <img
                src={client.logo}
                alt={client.name}
                loading="lazy"
                className="max-w-full h-auto transition-transform duration-300 hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>

      {/* CSS Animations and Glow */}
      <style jsx>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(16px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Subtle green glow on hover */
        .glow-hover:hover {
          box-shadow: 0 0 20px rgba(16, 185, 129, 0.6);
        }
      `}</style>
    </section>
  );
};
